'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var range = require('@mx/util/range');
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "picker"
    }, [_c('div', {
      staticClass: "picker-frame"
    }), _vm._v(" "), _c('ul', {
      style: _vm.style,
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": function touchmove($event) {
          $event.preventDefault();
          return _vm.onTouchMove($event);
        },
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, _vm._l(_vm.options, function (item, index) {
      return _c('li', {
        key: index,
        class: ['picker-item', {
          disabled: item.disabled,
          active: index === _vm.value
        }],
        attrs: {
          "data-key": "index"
        },
        domProps: {
          "textContent": _vm._s(item.text || item)
        },
        on: {
          "click": function click($event) {
            _vm.select(index);
          }
        }
      });
    }), 0)]);
  },
  staticRenderFns: [],
  name: 'picker',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    optionHeight: {
      type: Number,
      default: 50
    }
  },
  data: function data() {
    return {
      startY: 0,
      offset: 0,
      duration: 0,
      startOffset: 0
    };
  },
  computed: {
    style: function style() {
      return {
        transition: "".concat(this.duration, "ms"),
        transform: "translate3d(0, ".concat(this.offset, "px, 0)")
      };
    },
    count: function count() {
      return this.options.length;
    }
  },
  mounted: function mounted() {
    this.watchOptions();
  },
  methods: {
    watchOptions: function watchOptions() {
      this.select(this.value);
    },
    onTouchStart: function onTouchStart(event) {
      this.startY = event.touches[0].clientY;
      this.startOffset = this.offset;
      this.duration = 0;
    },
    onTouchMove: function onTouchMove(event) {
      var deltaY = event.touches[0].clientY - this.startY;
      this.offset = range.range(this.startOffset + deltaY, [-(this.count * this.optionHeight), this.optionHeight]);
    },
    onTouchEnd: function onTouchEnd() {
      if (this.offset !== this.startOffset) {
        this.duration = 200;
        var index = range.range(Math.round(-this.offset / this.optionHeight), [0, this.count - 1]);
        this.select(index);
      }
    },
    select: function select(index) {
      this.duration = 300;
      index = this.adjustIndex(index);
      this.offset = -index * this.optionHeight;

      if (this.value !== index && index !== undefined) {
        // 如果所有picker项为disabled，不去emit undefined值
        this.$emit('input', index);
      }
    },
    adjustIndex: function adjustIndex(index) {
      if (!this.options[index]) {
        return index;
      }

      for (var i = index; i < this.count; i++) {
        if (!this.options[i].disabled) return i;
      }

      for (var _i = index - 1; _i >= 0; _i--) {
        if (!this.options[_i].disabled) return _i;
      }
    }
  },
  watch: {
    options: function options() {
      this.watchOptions();
    },
    value: function value() {
      this.select(this.value);
    }
  }
});

exports.default = index;
